import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Card, CardHeader, CardBody } from "shards-react";
import axios from "axios";
import Loader from "react-loader-spinner";

import baseURL from "../common/axios-config";
import Chart from "../../utils/chart";

export default class AccountsCredits extends React.Component {
	constructor(props) {
		super(props);
		this.canvasRef = React.createRef();
		this.state = {
			chartData: this.props.chartData,
			load: false,
		};
	}

	componentDidMount() {
		const chartOptions = {
			...{
				responsive: true,
				legend: {
					position: "top",
				},
				elements: {
					line: {
						// A higher value makes the line look skewed at this ratio.
						tension: 0.3,
					},
					point: {
						radius: 0,
					},
				},
				scales: {
					yAxes: [
						{
							ticks: {
								stepSize: 100,
								beginAtZero: true,
							},
						},
					],
					xAxes: [
						{
							ticks: {
								callback: function(label) {
									return label.substring(0, 8);
								},
							},
						},
					],
				},
				hover: {
					mode: "nearest",
					intersect: false,
				},
				tooltips: {
					custom: false,
					mode: "nearest",
					intersect: false,
				},
			},
			...this.props.chartOptions,
		};

		this.StatisticsAccountsCredits = new Chart(this.canvasRef.current, {
			type: "bar",
			data: this.state.chartData,
			options: chartOptions,
		});

		this.StatisticsAccountsCredits.render();
		this.getAccountsCredits();
	}

	componentDidUpdate() {
		this.StatisticsAccountsCredits.update();
	}

	getAccountsCredits() {
		this.setState({ load: false });
		axios(baseURL + "/statistics-accountsCredits", {
			method: "POST",
			withCredentials: true,
		}).then((res) => {
			if (res.data.result === true) {
				this.setState({ load: true });
				this.props.chartData.labels = res.data.data.labels;
				this.props.chartData.datasets[0].data = res.data.data.data[0];
				this.props.chartData.datasets[1].data = res.data.data.data[1];
				this.setState({ chartData: this.props.chartData });
			}
		});
	}

	render() {
		const { title } = this.props;

		return (
			<Card small className="h-100">
				<CardHeader className="border-bottom">
					<h6 className="m-0">{title}</h6>
				</CardHeader>
				<CardBody className="pt-0 d-flex flex-column">
					<Row className="my-auto">
						{this.state.load === false ? <Col sm="12" className="d-flex">
								<div className="mx-auto my-auto">
									<Loader type="ThreeDots" color="#F96332" height={100} width={100} />
								</div>
						</Col> : ''}
						<canvas height="80" ref={this.canvasRef} style={this.state.load === false ? { display: "none",  maxWidth: "100% !important" } : { maxWidth: "100% !important" }} />
					</Row>
				</CardBody>
			</Card>
		);
	}
}

AccountsCredits.propTypes = {
	/**
	 * The component's title.
	 */
	title: PropTypes.string,
	/**
	 * The chart dataset.
	 */
	chartData: PropTypes.object,
	/**
	 * The Chart.js options.
	 */
	chartOptions: PropTypes.object,
};

AccountsCredits.defaultProps = {
	title: "Nombre de crédit par compte",
	chartData: {
		labels: null,
		datasets: [
			{
				label: "Crédits",
				fill: "start",
				data: null,
				backgroundColor: "rgba(0,123,255,0.1)",
				borderColor: "rgba(0,123,255,1)",
				pointBackgroundColor: "#ffffff",
				pointHoverBackgroundColor: "rgb(0,123,255)",
				borderWidth: 1.5,
				pointRadius: 0,
				pointHoverRadius: 3,
			},{
				label: "Consommation",
				fill: "start",
				data: null,
				backgroundColor: "rgba(23,198,113,0.1)",
				borderColor: "rgba(23,198,113,1)",
				pointBackgroundColor: "#ffffff",
				pointHoverBackgroundColor: "rgb(23,198,113)",
				borderWidth: 1.5,
				pointRadius: 0,
				pointHoverRadius: 3,
			},
		],
	},
};
